var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExclamationCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4954 13.0002C23.4954 18.7976 18.7964 23.495 13.0007 23.495C7.20494 23.495 2.50586 18.7976 2.50586 13.0002C2.50586 7.20615 7.20494 2.50537 13.0007 2.50537C18.7964 2.50537 23.4954 7.20615 23.4954 13.0002ZM13.0007 15.116C11.9256 15.116 11.054 15.9876 11.054 17.0627C11.054 18.1377 11.9256 19.0093 13.0007 19.0093C14.0757 19.0093 14.9473 18.1377 14.9473 17.0627C14.9473 15.9876 14.0757 15.116 13.0007 15.116ZM11.4664 13.8742L11.1525 8.11898C11.1366 7.82809 11.3682 7.5835 11.6595 7.5835H14.3417C14.6331 7.5835 14.8647 7.82809 14.8488 8.11898L14.5349 13.8742C14.5202 14.1435 14.2975 14.3543 14.0278 14.3543H11.9735C11.7038 14.3543 11.4811 14.1435 11.4664 13.8742Z",
    fill: "#F26722"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3780_21491",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 22,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4954 13.0002C23.4954 18.7976 18.7964 23.495 13.0007 23.495C7.20494 23.495 2.50586 18.7976 2.50586 13.0002C2.50586 7.20615 7.20494 2.50537 13.0007 2.50537C18.7964 2.50537 23.4954 7.20615 23.4954 13.0002ZM13.0007 15.116C11.9256 15.116 11.054 15.9876 11.054 17.0627C11.054 18.1377 11.9256 19.0093 13.0007 19.0093C14.0757 19.0093 14.9473 18.1377 14.9473 17.0627C14.9473 15.9876 14.0757 15.116 13.0007 15.116ZM11.4664 13.8742L11.1525 8.11898C11.1366 7.82809 11.3682 7.5835 11.6595 7.5835H14.3417C14.6331 7.5835 14.8647 7.82809 14.8488 8.11898L14.5349 13.8742C14.5202 14.1435 14.2975 14.3543 14.0278 14.3543H11.9735C11.7038 14.3543 11.4811 14.1435 11.4664 13.8742Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3780_21491)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExclamationCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/exclamation-circle.2fcb23b6eca94466250860fe7c95a254.svg";